import { z } from 'zod';
import { ProjectNumberSchema } from '@schuettflix/interfaces';

export const CustomerInfoSchema = z.object({
    constructionProjectId: z.string().uuid(),
    projectNumber: ProjectNumberSchema.optional(),
    organizationId: z.number(),
    userId: z.number(),
    manualCostCenter: z.string().nullable(),
});

export type CustomerInfo = z.infer<typeof CustomerInfoSchema>;
